export default __webpack_public_path__ + "static/media/2223 knife block A side.14c7177b.png";